window.addEventListener('DOMContentLoaded', (event) => {
  const topSlider = document.querySelector('.slideWrapper')
  if (topSlider) {
    const ul = topSlider.querySelector('.keen-slider')
    const children = Array.from(ul.children)
    const slide = KeenSlider(ul, {
      slides: {
        perView: 1,
        spacing: 24
      },
      selector: children,
      breakpoints: {
        '(max-width: 768px)': {
          slides: {
            spacing: 10
          }
        }
      }
    })
    const arrows = topSlider.querySelectorAll('.arrow')
    arrows.forEach((arrow) => {
      const isNext = arrow.classList.contains('next')
      arrow.addEventListener('click', isNext ? slide.next : slide.prev)
    })
  }
  const photoSliders = document.querySelectorAll('.photoSlider')
  if (photoSliders) {
    photoSliders.forEach((photoSlider) => {
      const ul = photoSlider.querySelector('.keen-slider')
      const children = Array.from(ul.children)
      const slide = KeenSlider(ul, {
        mode: 'free-snap',
        slides: {
          origin: 'center',
          perView: 'auto',
          spacing: 24
        },
        selector: children
      })
      const arrows = photoSlider.querySelectorAll('.arrow')
      arrows.forEach((arrow) => {
        const isNext = arrow.classList.contains('next')
        arrow.addEventListener('click', isNext ? slide.next : slide.prev)
      })
    })
  }

  // Google Tag
  const currentURL = window.location.pathname;
  let articlePattern = /^\/(article|movie|gift)\/detail\/\d+$/;
  if (articlePattern.test(currentURL)) {
    // 記事内の3つ目のh2の上にGAMタグ設置
    let setGamFlag = false;
    const bodySections = document.querySelectorAll('.bodySection');
    if (bodySections.length > 0) {
      bodySections.forEach(function(section) {
        // bodySection内のh2要素を取得
        let h2Elements = section.getElementsByTagName('h2');
        if (h2Elements.length >= 3) {
          setGamFlag = true;
          // 3番目のh2要素の前に広告タグを挿入
          let thirdH2 = h2Elements[2];
          let adTemplate = document.createElement('div');
          adTemplate.className = 'adArea';
          adTemplate.innerHTML = '<div id="div-gpt-ad-1713177973625-0" style="min-width: 300px; min-height: 250px;"></div>';
          // 3番目のh2要素の前に挿入
          section.insertBefore(adTemplate, thirdH2);
        }
      });
    }
    // タグ設定
    window.googletag = window.googletag || {cmd: []};
    googletag.cmd.push(function() {
      googletag.display('div-gpt-ad-1695280340066-0');
      googletag.display('div-gpt-ad-1700804614303-0');
      if (setGamFlag) {
        googletag.display('div-gpt-ad-1713177973625-0'); // aloco_in_article_h2_2_rectangle
      }
      const yourRecommended = document.querySelector('.yourRecommended');
      if (yourRecommended) {
        googletag.display('div-gpt-ad-1713178685732-0'); // aloco_article_footer_recommend
      }
    });
  }
});
